import { render, staticRenderFns } from "./PartnerResult.vue?vue&type=template&id=196fe385&scoped=true"
import script from "./PartnerResult.vue?vue&type=script&lang=js"
export * from "./PartnerResult.vue?vue&type=script&lang=js"
import style0 from "./PartnerResult.vue?vue&type=style&index=0&id=196fe385&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196fe385",
  null
  
)

export default component.exports